/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type SubscriptionCode = "RTP_CU" | "RTP_CX" | "RTP_OC" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SubscriptionTemplateLoaderFragment_viewer$ref: FragmentReference;
declare export opaque type SubscriptionTemplateLoaderFragment_viewer$fragmentType: SubscriptionTemplateLoaderFragment_viewer$ref;
export type SubscriptionTemplateLoaderFragment_viewer = {|
  +subscriptionTemplates: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +code: SubscriptionCode,
        +name: string,
      |}
    |}>
  |},
  +$refType: SubscriptionTemplateLoaderFragment_viewer$ref,
|};
export type SubscriptionTemplateLoaderFragment_viewer$data = SubscriptionTemplateLoaderFragment_viewer;
export type SubscriptionTemplateLoaderFragment_viewer$key = {
  +$data?: SubscriptionTemplateLoaderFragment_viewer$data,
  +$fragmentRefs: SubscriptionTemplateLoaderFragment_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SubscriptionTemplateLoaderFragment_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "subscriptionTemplates",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        }
      ],
      "concreteType": "SubscriptionTemplateNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "SubscriptionTemplateNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "SubscriptionTemplateNode",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8465cc0b482fa809757f4a5b4ea31909';
module.exports = node;
